export function filterNewsFeed(entry: InboxArticle): boolean {
    if (!entry.showInNewsFeed) {
        return true;
    }

    return entry.showInNewsFeed === "SHOW_IN_NEWS_FEED";
}
